// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__rTKYE","additionalInfo":"AgreementModal_additionalInfo__3E5-L"};